var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDtmCapabilityImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 201,
    viewBox: "0 0 200 201",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.875 19.25V6.75H193.75V181.75H181.25L71.875 19.25Z",
    fill: "#FFF3C9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M187.5 50.5V181.75H181.25L71.875 19.25H156.25L187.5 50.5Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M137.5 188H181.25V50.5L150 19.25H65.625V38V100.5V119.25L137.5 188Z",
    fill: "#FFECAE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M65.625 119.25V116.125H78.125L90.625 103.625H134.375C136.033 103.625 137.622 104.283 138.794 105.456C139.967 106.628 140.625 108.217 140.625 109.875V184.875C140.618 185.975 140.32 187.053 139.759 188H137.5L65.625 119.25Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M150 19.25V50.5H181.25L150 19.25Z",
    fill: "#FFD55D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 119.25H75L87.5 106.75H131.25C132.908 106.75 134.497 107.408 135.669 108.581C136.842 109.753 137.5 111.342 137.5 113V188C137.5 189.658 136.842 191.247 135.669 192.419C134.497 193.592 132.908 194.25 131.25 194.25H12.5C10.8424 194.25 9.25268 193.592 8.08058 192.419C6.90848 191.247 6.25 189.658 6.25 188V125.5C6.25 123.842 6.90848 122.253 8.08058 121.081C9.25268 119.908 10.8424 119.25 12.5 119.25Z",
    fill: "#FFD55D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 131.75H125V194.25H12.5C10.8424 194.25 9.25268 193.592 8.08058 192.419C6.90848 191.247 6.25 189.658 6.25 188V131.75Z",
    fill: "#FFC239"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.625 178.625H21.875V184.875H15.625V178.625Z",
    fill: "#5A5B5D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M28.125 178.625H78.125V184.875H28.125V178.625Z",
    fill: "#5A5B5D"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M15.625 166.125H21.875V172.375H15.625V166.125Z",
    fill: "#5A5B5D"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M28.125 166.125H78.125V172.375H28.125V166.125Z",
    fill: "#5A5B5D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M115.625 84.875L103.125 94.25L90.625 84.875C86.7439 81.9642 83.5938 78.1897 81.4242 73.8504C79.2545 69.5112 78.125 64.7264 78.125 59.875V38H82.4812C89.8286 38 97.0115 35.8253 103.125 31.75C109.239 35.8253 116.421 38 123.769 38H128.125V59.875C128.125 64.7264 126.995 69.5112 124.826 73.8504C122.656 78.1897 119.506 81.9642 115.625 84.875Z",
    fill: "#009245"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M115.625 84.875C119.506 81.9642 122.656 78.1897 124.826 73.8504C126.995 69.5112 128.125 64.7264 128.125 59.875V38H123.769C116.421 38 109.239 35.8253 103.125 31.75V94.25L115.625 84.875Z",
    fill: "#00AA4D"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M103.125 75.5C102.64 75.5 102.161 75.387 101.727 75.1701C101.294 74.9531 100.916 74.6381 100.625 74.25L91.25 61.75L96.25 58L102.431 66.2406L112.769 42.9812L118.481 45.5187L105.981 73.6437C105.761 74.1412 105.414 74.5724 104.975 74.8947C104.537 75.217 104.022 75.4192 103.481 75.4812C103.363 75.4939 103.244 75.5002 103.125 75.5Z",
    fill: "#E5E5E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDtmCapabilityImage);
export default __webpack_public_path__ + "static/media/dtm-capability-image.dc9b8b96.svg";
export { ForwardRef as ReactComponent };